import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { MdError } from 'react-icons/md';

import styles from './WarningMessage.less';

const WarningMessage = ({ className, children }) => (
  <div className={cn(className, styles.container)}>
    <MdError className={styles.icon} />
    <div className={styles.text}>{children}</div>
  </div>
);

WarningMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default WarningMessage;
